module.exports = __webpack_public_path__ + "static/media/icon-search.53dfaed6.svg";